import { Controller, useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';

/**
 * Store name input component
 * Handles store name field using React Hook Form with Controller
 */
export const StoreNameInput = () => {
  const { t } = useTranslation(['stores', 'common']);
  const {
    control,
    formState: { errors },
  } = useFormContext<{ name: string }>();

  return (
    <div className="space-y-2">
      <div className="flex items-center gap-1">
        <Label htmlFor="name">{t('form.name')}</Label>
        <span className="text-red-500">*</span>
      </div>
      <Controller
        name="name"
        control={control}
        render={({ field }) => (
          <Input
            id="store-name-input"
            {...field}
            value={field.value || ''}
            placeholder={t('form.namePlaceholder')}
          />
        )}
      />
      {errors.name && <p className="text-sm text-red-500">{errors.name.message as string}</p>}
    </div>
  );
};
